import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FerienhauserextrafiltersComponent } from './ferienhauserextrafilters.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '@app/material.module';
import { DoublesliderModule } from '../doubleslider/doubleslider.module';
import { SelectionbtnModule } from '../selectionbtn/selectionbtn.module';
import { FerienhauserselectedfiltersComponent } from './ferienhauserselectedfilters/ferienhauserselectedfilters.component';

@NgModule({
    declarations: [
        FerienhauserextrafiltersComponent,
        FerienhauserselectedfiltersComponent
    ],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        DoublesliderModule,
        SelectionbtnModule
    ],
    exports: [
        FerienhauserextrafiltersComponent,
        FerienhauserselectedfiltersComponent
    ]
})
export class FerienhauserextrafiltersModule { }
